import React, { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import ic_doc_download_light from "../../assets/images/ic_doc_download_light.svg";
import ic_view_light from "../../assets/images/ic_view_light.svg";
import ic_repeat from "../../assets/images/ic_repeat.svg";
import ic_repeat_green from "../../assets/images/ic_repeat_green.svg";
import chatting_dummy from "../../assets/images/chatting_dummy.png";
import video_dummy from "../../assets/images/video_dummy.png";

import ic_add_plus from "../../assets/images/ic_add_plus.svg";
import ic_arrow_right_white from "../../assets/images/ic_right_arrow_circle.svg";
import dr_1 from "../../assets/images/dr_1.png";
import ic_doc_download from "../../assets/images/ic_doc_download.svg";
import ic_view from "../../assets/images/ic_view.svg";
import ic_video from "../../assets/images/ic_video.svg";
import ic_calender_green from "../../assets/images/ic_calender_green.svg";
import dog_1 from "../../assets/images/dog_1.png";
import dog_3 from "../../assets/images/dog_3.png";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import ic_progress from "../../assets/images/ic_progress.svg";
import ic_complete from "../../assets/images/ic_complete.svg";
import ic_reject from "../../assets/images/ic_reject.svg";
import ic_left_green_arrow from "../../assets/images/ic_left_green_arrow.svg";
import ic_star_active from "../../assets/images/ic_star_active.svg";
import ic_start from "../../assets/images/ic_start.svg";

import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import PrescriptionComp from "./PrescriptionComp";
const MyAppointmentsComp = () => {
  const [viewAppDetails, setViewAppDetails] = useState(true);
  const [StartBtn, setStartBtn] = useState(false);
  const [StartViewBtn, setStartViewBtn] = useState(false);
  const { Prescription, setPrescription } = useContext(AppContext);
  const [VideoChatting, setVideoChatting] = useState(true);
  const [ReviewBtn, setReviewBtn] = useState(false);
  const [RewiewForm, setRewiewForm] = useState(false);
  const [RewiewDetails, setRewiewDetails] = useState(false);

  return (
    <div id="my-appointment-wrapper">
      {VideoChatting ? (
        <div className="right-section">
          <section className="wrapper-cards ">
            <div className="heading-close-btn">
              <h5>My Appointments (20)</h5>
              <Link onClick={() => setViewAppDetails(false)}>
                <img src={ic_calender_green} alt="" />
              </Link>
            </div>
          </section>
          {viewAppDetails ? (
            <div className="appointment">
              <div className="appointment-date-wrapper">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          d="M10.6624 1.8418C6.07077 1.8418 2.3291 5.58346 2.3291 10.1751C2.3291 14.7668 6.07077 18.5085 10.6624 18.5085C15.2541 18.5085 18.9958 14.7668 18.9958 10.1751C18.9958 5.58346 15.2541 1.8418 10.6624 1.8418ZM14.2874 13.1501C14.2457 13.2211 14.1903 13.2832 14.1244 13.3326C14.0585 13.382 13.9834 13.4178 13.9036 13.438C13.8237 13.4581 13.7407 13.4622 13.6592 13.45C13.5777 13.4378 13.4995 13.4095 13.4291 13.3668L10.8458 11.8251C10.2041 11.4418 9.7291 10.6001 9.7291 9.85846V6.4418C9.7291 6.10013 10.0124 5.8168 10.3541 5.8168C10.6958 5.8168 10.9791 6.10013 10.9791 6.4418V9.85846C10.9791 10.1585 11.2291 10.6001 11.4874 10.7501L14.0708 12.2918C14.3708 12.4668 14.4708 12.8501 14.2874 13.1501Z"
                          fill="#9AB7B8"
                        />
                      </svg>
                      Request Sent
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="b-c ">
                    <img src={ic_view} alt="" />
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="full-btn grey-btn">
                    <img src={ic_video} alt="" />
                    Start
                  </button>
                </div>
              </section>

              <div className="appointment-date-wrapper mt-4">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value" id="accepted-status">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          d="M2.3291 10.6751C2.3291 6.08346 6.07077 2.3418 10.6624 2.3418C15.2541 2.3418 18.9958 6.08346 18.9958 10.6751C18.9958 15.2668 15.2541 19.0085 10.6624 19.0085C6.07077 19.0085 2.3291 15.2668 2.3291 10.6751Z"
                          fill="#05CD99"
                        />
                      </svg>
                      Request Accepted
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="b-c ">
                    <img src={ic_view} alt="" />
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="full-btn green-btn">
                    <img src={ic_video} alt="" />
                    Start
                  </button>
                </div>
              </section>

              <div className="appointment-date-wrapper mt-4">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          d="M10.6624 1.8418C6.07077 1.8418 2.3291 5.58346 2.3291 10.1751C2.3291 14.7668 6.07077 18.5085 10.6624 18.5085C15.2541 18.5085 18.9958 14.7668 18.9958 10.1751C18.9958 5.58346 15.2541 1.8418 10.6624 1.8418ZM14.2874 13.1501C14.2457 13.2211 14.1903 13.2832 14.1244 13.3326C14.0585 13.382 13.9834 13.4178 13.9036 13.438C13.8237 13.4581 13.7407 13.4622 13.6592 13.45C13.5777 13.4378 13.4995 13.4095 13.4291 13.3668L10.8458 11.8251C10.2041 11.4418 9.7291 10.6001 9.7291 9.85846V6.4418C9.7291 6.10013 10.0124 5.8168 10.3541 5.8168C10.6958 5.8168 10.9791 6.10013 10.9791 6.4418V9.85846C10.9791 10.1585 11.2291 10.6001 11.4874 10.7501L14.0708 12.2918C14.3708 12.4668 14.4708 12.8501 14.2874 13.1501Z"
                          fill="#9AB7B8"
                        />
                      </svg>
                      Request Accepted
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="full-btn green-btn ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      className="me-1"
                    >
                      <path
                        d="M16.1405 12.6796C16.1405 14.6596 14.5405 16.2596 12.5605 16.2596C10.5805 16.2596 8.98047 14.6596 8.98047 12.6796C8.98047 10.6996 10.5805 9.09961 12.5605 9.09961C14.5405 9.09961 16.1405 10.6996 16.1405 12.6796Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5604 20.9504C16.0904 20.9504 19.3804 18.8704 21.6704 15.2704C22.5704 13.8604 22.5704 11.4904 21.6704 10.0804C19.3804 6.48039 16.0904 4.40039 12.5604 4.40039C9.03039 4.40039 5.74039 6.48039 3.45039 10.0804C2.55039 11.4904 2.55039 13.8604 3.45039 15.2704C5.74039 18.8704 9.03039 20.9504 12.5604 20.9504Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    View
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="b-c">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M11.9697 22.0918C17.4927 22.0918 21.9697 17.6148 21.9697 12.0918C21.9697 6.5688 17.4927 2.0918 11.9697 2.0918C6.44673 2.0918 1.96973 6.5688 1.96973 12.0918C1.96973 17.6148 6.44673 22.0918 11.9697 22.0918Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.74023 12.3224V10.6524C8.74023 8.57241 10.2102 7.72241 12.0102 8.76241L13.4602 9.60241L14.9102 10.4424C16.7102 11.4824 16.7102 13.1824 14.9102 14.2224L13.4602 15.0624L12.0102 15.9024C10.2102 16.9424 8.74023 16.0924 8.74023 14.0124V12.3224Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </section>

              <div className="appointment-date-wrapper mt-4">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value" id="progress-status">
                      <img src={ic_progress} alt="" className="me-1" />
                      In Progress
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="full-btn green-btn ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      className="me-1"
                    >
                      <path
                        d="M16.1405 12.6796C16.1405 14.6596 14.5405 16.2596 12.5605 16.2596C10.5805 16.2596 8.98047 14.6596 8.98047 12.6796C8.98047 10.6996 10.5805 9.09961 12.5605 9.09961C14.5405 9.09961 16.1405 10.6996 16.1405 12.6796Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5604 20.9504C16.0904 20.9504 19.3804 18.8704 21.6704 15.2704C22.5704 13.8604 22.5704 11.4904 21.6704 10.0804C19.3804 6.48039 16.0904 4.40039 12.5604 4.40039C9.03039 4.40039 5.74039 6.48039 3.45039 10.0804C2.55039 11.4904 2.55039 13.8604 3.45039 15.2704C5.74039 18.8704 9.03039 20.9504 12.5604 20.9504Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    View
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="b-c">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M11.9697 22.0918C17.4927 22.0918 21.9697 17.6148 21.9697 12.0918C21.9697 6.5688 17.4927 2.0918 11.9697 2.0918C6.44673 2.0918 1.96973 6.5688 1.96973 12.0918C1.96973 17.6148 6.44673 22.0918 11.9697 22.0918Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.74023 12.3224V10.6524C8.74023 8.57241 10.2102 7.72241 12.0102 8.76241L13.4602 9.60241L14.9102 10.4424C16.7102 11.4824 16.7102 13.1824 14.9102 14.2224L13.4602 15.0624L12.0102 15.9024C10.2102 16.9424 8.74023 16.0924 8.74023 14.0124V12.3224Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </section>

              <div className="appointment-date-wrapper mt-4">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value" id="progress-status">
                      <img src={ic_complete} alt="" className="me-1" />
                      Completed
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="full-btn green-btn ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      className="me-1"
                    >
                      <path
                        d="M16.1405 12.6796C16.1405 14.6596 14.5405 16.2596 12.5605 16.2596C10.5805 16.2596 8.98047 14.6596 8.98047 12.6796C8.98047 10.6996 10.5805 9.09961 12.5605 9.09961C14.5405 9.09961 16.1405 10.6996 16.1405 12.6796Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5604 20.9504C16.0904 20.9504 19.3804 18.8704 21.6704 15.2704C22.5704 13.8604 22.5704 11.4904 21.6704 10.0804C19.3804 6.48039 16.0904 4.40039 12.5604 4.40039C9.03039 4.40039 5.74039 6.48039 3.45039 10.0804C2.55039 11.4904 2.55039 13.8604 3.45039 15.2704C5.74039 18.8704 9.03039 20.9504 12.5604 20.9504Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    View
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="b-c">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M11.9697 22.0918C17.4927 22.0918 21.9697 17.6148 21.9697 12.0918C21.9697 6.5688 17.4927 2.0918 11.9697 2.0918C6.44673 2.0918 1.96973 6.5688 1.96973 12.0918C1.96973 17.6148 6.44673 22.0918 11.9697 22.0918Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.74023 12.3224V10.6524C8.74023 8.57241 10.2102 7.72241 12.0102 8.76241L13.4602 9.60241L14.9102 10.4424C16.7102 11.4824 16.7102 13.1824 14.9102 14.2224L13.4602 15.0624L12.0102 15.9024C10.2102 16.9424 8.74023 16.0924 8.74023 14.0124V12.3224Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </section>

              <div className="appointment-date-wrapper mt-4">
                <label htmlFor="">21 July, 2023</label>
                <div className="line"></div>
              </div>

              <section className="wrapper-cards ">
                <div className="app-details-wrapper">
                  <div className="img-dr">
                    <img src={dr_1} alt="" />
                    <div className="right-dr">
                      <label htmlFor="" className="key">
                        Dr. Floyd Miles
                      </label>
                      <p className="value">Orthopedic | 5 years</p>
                    </div>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Animal
                    </label>
                    <p className="value">Bruno | Cat</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <p className="value">Video Consultation</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Fees
                    </label>
                    <p className="value">₹100</p>
                  </div>

                  <div className="detail">
                    <label htmlFor="" className="key">
                      Status
                    </label>
                    <p className="value" id="progress-status">
                      <img src={ic_reject} alt="" className="me-1" />
                      Rejected
                    </p>
                  </div>
                </div>
                <div className="app-btn-wrapper">
                  <button className="full-btn green-btn ">
                    <img src={ic_view_light} alt="" />
                    View
                  </button>
                  <button className="b-c mx-4">
                    <img src={ic_doc_download} alt="" />
                  </button>
                  <button className="b-c">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M11.9697 22.0918C17.4927 22.0918 21.9697 17.6148 21.9697 12.0918C21.9697 6.5688 17.4927 2.0918 11.9697 2.0918C6.44673 2.0918 1.96973 6.5688 1.96973 12.0918C1.96973 17.6148 6.44673 22.0918 11.9697 22.0918Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.74023 12.3224V10.6524C8.74023 8.57241 10.2102 7.72241 12.0102 8.76241L13.4602 9.60241L14.9102 10.4424C16.7102 11.4824 16.7102 13.1824 14.9102 14.2224L13.4602 15.0624L12.0102 15.9024C10.2102 16.9424 8.74023 16.0924 8.74023 14.0124V12.3224Z"
                        stroke="#f9bc03"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </section>
            </div>
          ) : (
            <div className="appointment-details-wrapper">
              <div className="show-back-heading">
                <Link onClick={() => setViewAppDetails(true)}>
                  <img src={ic_left_green_arrow} alt="" />
                </Link>
                <label htmlFor="">
                  Showing result for : <span>Appointment -1</span>
                </label>
              </div>
              <div className="wrapper-cards">
                <h6>Appointment - 1</h6>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="" className="key">
                      Name
                    </label>
                    <span className="value">Dr. Floyd Miles</span>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="" className="key">
                      Appointment Date & Time
                    </label>
                    <span className="value">02-02-2023, 04:30 PM</span>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="" className="key">
                      Appointment Type
                    </label>
                    <span className="value">
                      At Clinic
                      <img src={ic_complete} alt="" className="mx-1" />
                      <span id="completed">Paid</span>
                    </span>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="" className="key">
                      Description
                    </label>
                    <span className="value">
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, to Sed ut
                      perspiciatis unde omnis iste natus error sit voluptatem
                      accusantium doloremque{" "}
                    </span>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="" className="key">
                      Photos / Videos
                    </label>
                    <div className="img-wrapper">
                      <div className="img me-3">
                        <img src={dog_1} alt="" className="animal-img" />
                      </div>

                      <div className="img me-3">
                        <img src={dog_3} alt="" className="animal-img" />
                        <Link>
                          <img src={ic_video} alt="" className="ic-video" />
                        </Link>
                      </div>
                      <div className="img me-3">
                        <img src={dog_1} alt="" className="animal-img" />
                      </div>

                      <div className="img me-3">
                        <img src={dog_3} alt="" className="animal-img" />
                        <Link>
                          <img src={ic_video} alt="" className="ic-video" />
                        </Link>
                      </div>
                      <div className="img me-3">
                        <img src={dog_1} alt="" className="animal-img" />
                      </div>

                      <div className="img me-3">
                        <img src={dog_3} alt="" className="animal-img" />
                        <Link>
                          <img src={ic_video} alt="" className="ic-video" />
                        </Link>
                      </div>
                    </div>
                  </div>

                  {RewiewDetails ? (
                    <div className="col-12">
                      <label htmlFor="" className="key">
                        Ratings & Review
                      </label>
                      <div className="review-details">
                        <div className="heading-rating">
                          <div className="left">
                            <label htmlFor="" className="value">
                              Regular health check up.
                            </label>
                            <p className="key">Dr. Rohit Sharma</p>
                          </div>
                          <div className="right">
                            <img src={ic_star_active} alt="" /> <span>4.1</span>
                          </div>
                        </div>
                        <div className="value">
                          Ut enim ad minima veniam, quis nostrum exercitationem
                          ullam corporis suscipit laboriosam, nisi ut al Ut enim
                          ad minima veniam, quis nostrum exercitationem ullam
                          corporis suscipit laboriosam, nisi ut al
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {ReviewBtn ? (
                    <div className="col-12">
                      <label htmlFor="" className="key">
                        Ratings & Review
                      </label>
                      <div className="review-write-btn-wrapper ">
                        <button
                          onClick={() => {
                            setRewiewForm(true);
                            setReviewBtn(false);
                          }}
                        >
                          Write a Review...
                        </button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="btn-wrapper">
                    {StartViewBtn ? (
                      <>
                        <button
                          className="btn-blank-green"
                          onClick={() => setPrescription(true)}
                        >
                          <img src={ic_view} alt="" />
                          View
                        </button>
                        <button className="btn-blank-green">
                          <img src={ic_doc_download} alt="" />
                          Download
                        </button>
                        <button
                          className="btn-blank-green"
                          onClick={() => setVideoChatting(false)}
                        >
                          <img src={ic_repeat_green} alt="" />
                          Re-Schedule
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="blank-btn me-3"
                          onClick={() => setStartBtn(false)}
                        >
                          Back
                        </button>

                        {StartBtn ? (
                          <button
                            className="filled-start"
                            onClick={() => setStartViewBtn(true)}
                          >
                            Start (59s)
                          </button>
                        ) : (
                          <button
                            className="filled-btn"
                            onClick={() => setStartBtn(true)}
                          >
                            Start
                          </button>
                        )}
                      </>
                    )}
                  </div>

                  <PrescriptionComp />
                </div>
              </div>

              {/* ===================== REWIEW FORM SECTION =========================== */}

              {RewiewForm ? (
                <div className="wrapper-cards mt-3">
                  <h6>Write a Review</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="" className="key">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title goes here..."
                      />
                    </div>
                    <div className="col-md-6 mb-3 text-end">
                      <Link className="ms-2">
                        <img src={ic_star_active} alt="" />
                      </Link>
                      <Link className="ms-2">
                        <img src={ic_star_active} alt="" />
                      </Link>
                      <Link className="ms-2">
                        <img src={ic_start} alt="" />
                      </Link>
                      <Link className="ms-2">
                        <img src={ic_start} alt="" />
                      </Link>
                      <Link className="ms-2">
                        <img src={ic_start} alt="" />
                      </Link>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label htmlFor="" className="key">
                        Description
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Write your review"
                      />
                    </div>

                    <div className="btn-wrapper">
                      <>
                        <button
                          className="btn-blank-green"
                          onClick={() => setPrescription(true)}
                        >
                          cancel
                        </button>
                        <button
                          className="btn-blank-green"
                          onClick={() => {
                            setReviewBtn(false);
                            setRewiewDetails(true);
                            setRewiewForm(false);
                          }}
                          style={{
                            backgroundColor: "#f9bc03",
                            color: "#E9F5FB"
                          }}
                        >
                          Submit
                        </button>
                      </>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="wrapper-cards mt-3 " id="tabs-app-details">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Nav variant="pills" className="flex-row">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Appointments</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Invoices</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="first-tab-con">
                        <div className="appointment-date-wrapper mt-4">
                          <label htmlFor="">Today</label>
                          <div className="line"></div>
                        </div>

                        <section
                          className="wrapper-cards mb-3"
                          id="bg-dark-card"
                        >
                          <div className="app-details-wrapper">
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Animal
                              </label>
                              <p className="value">Bruno | Cat</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Appointment Type
                              </label>
                              <p className="value">Video Consultation</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Fees
                              </label>
                              <p className="value">₹100</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Status
                              </label>
                              <p className="value" id="progress-status">
                                <img
                                  src={ic_complete}
                                  alt=""
                                  className="me-1"
                                />
                                Complete
                              </p>
                            </div>
                          </div>
                          <div className="app-btn-wrapper">
                            <button className="b-c ">
                              <img src={ic_view_light} alt="" />
                            </button>
                            <button className="b-c mx-4">
                              <img src={ic_doc_download_light} alt="" />
                            </button>
                            <button
                              className="full-btn green-btn"
                              onClick={() => setVideoChatting(false)}
                            >
                              <img src={ic_repeat} alt="" /> Re-Schedule
                            </button>
                          </div>
                        </section>
                        <div className="appointment-date-wrapper mt-4">
                          <label htmlFor="">09 July, 2023</label>
                          <div className="line"></div>
                        </div>
                        <section className="wrapper-cards" id="bg-light-card">
                          <div className="app-details-wrapper">
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Animal
                              </label>
                              <p className="value">Bruno | Cat</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Appointment Type
                              </label>
                              <p className="value">Video Consultation</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Fees
                              </label>
                              <p className="value">₹100</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Status
                              </label>
                              <p className="value" id="progress-status">
                                <img
                                  src={ic_complete}
                                  alt=""
                                  className="me-1"
                                />
                                Complete
                              </p>
                            </div>
                          </div>
                          <div className="app-btn-wrapper">
                            <button className="b-c ">
                              <img src={ic_view} alt="" />
                            </button>
                            <button className="b-c mx-4">
                              <img src={ic_doc_download} alt="" />
                            </button>
                            <button
                              className="full-btn green-btn"
                              id="reapeat-btn"
                              onClick={() => setVideoChatting(false)}
                            >
                              <img src={ic_repeat} alt="" /> Re-Schedule
                            </button>
                          </div>
                        </section>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <div className="first-tab-con">
                        <div className="appointment-date-wrapper mt-4">
                          <label htmlFor="">Today</label>
                          <div className="line"></div>
                        </div>

                        <section
                          className="wrapper-cards mb-3"
                          id="bg-dark-card"
                        >
                          <div className="app-details-wrapper">
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Animal
                              </label>
                              <p className="value">Bruno | Cat</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Appointment Type
                              </label>
                              <p className="value">Video Consultation</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Fees
                              </label>
                              <p className="value">₹100</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Status
                              </label>
                              <p className="value" id="progress-status">
                                <img
                                  src={ic_complete}
                                  alt=""
                                  className="me-1"
                                />
                                Complete
                              </p>
                            </div>
                          </div>
                          
                        </section>
                        <div className="appointment-date-wrapper mt-4">
                          <label htmlFor="">09 July, 2023</label>
                          <div className="line"></div>
                        </div>
                        <section className="wrapper-cards" id="bg-light-card">
                          <div className="app-details-wrapper">
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Animal
                              </label>
                              <p className="value">Bruno | Cat</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Appointment Type
                              </label>
                              <p className="value">Video Consultation</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Fees
                              </label>
                              <p className="value">₹100</p>
                            </div>
                            <div className="detail">
                              <label htmlFor="" className="key">
                                Status
                              </label>
                              <p className="value" id="progress-status">
                                <img
                                  src={ic_complete}
                                  alt=""
                                  className="me-1"
                                />
                                Complete
                              </p>
                            </div>
                          </div>
                          
                        </section>
                      </div>
                    </Tab.Pane>{" "}
                  </Tab.Content>
                </Tab.Container>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="video-chatting-wrapper">
          <div className="row">
            <div className="col-md-8">
              <div className="left-video wrapper-cards">
                <img src={video_dummy} alt="" className="w-100" />
                <div className="text-center">
                  <button
                    onClick={() => {
                      setVideoChatting(true);
                      setReviewBtn(true);
                    }}
                    className="btn bg-danger text-light"
                  >
                    End Call
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="right-chatting wrapper-cards">
                <img src={chatting_dummy} alt="" className="w-100" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAppointmentsComp;
